/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Спецификация АПИ управления сущностью SafeCityEmergencyFile
 */

/**
 * Сервис управления файлами оповещением
 */
export class SafeCityEmergencyFileServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления единичной сущности SafeCityEmergencyFile по ключу
   */
  DeleteSafeCityEmergencyFile = (req: DeleteSafeCityEmergencyFileRequestDto, init?: RequestInit): Promise<DeleteSafeCityEmergencyFileResponseDto> => {
    return fm.request<DeleteSafeCityEmergencyFileRequestDto, DeleteSafeCityEmergencyFileResponseDto>(`${this.host}/device/api/v1/safe_city/emergency_file/${encodeURIComponent(req.fileName)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка файлов оповещения.
   * В ответе только массив file_name, необязательный параметр content не присутствует
   */
  GetSafeCityEmergencyFileList = (req?: GetSafeCityEmergencyFileListRequestDto, init?: RequestInit): Promise<GetSafeCityEmergencyFileListResponseDto> => {
    return fm.request<GetSafeCityEmergencyFileListRequestDto, GetSafeCityEmergencyFileListResponseDto>(`${this.host}/device/api/v1/safe_city/emergency_file/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод загрузки файла на устройство.
   * Syslog: EVENT:000: Upload Emergency File: File size nnn byte: File Duration nnn sec
   */
  SaveSafeCityEmergencyFile = (req: SaveSafeCityEmergencyFileRequestDto, init?: RequestInit): Promise<SaveSafeCityEmergencyFileResponseDto> => {
    return fm.request<SaveSafeCityEmergencyFileRequestDto, SaveSafeCityEmergencyFileResponseDto>(`${this.host}/device/api/v1/safe_city/emergency_file`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос удаления единичной сущности SafeCityEmergencyFile по ключу
 */
export type DeleteSafeCityEmergencyFileRequestDto = {
  /**
   * Имя файла
   */
  fileName: string
}
/**
 * Ответ на запрос удаления единичной сущности SafeCityEmergencyFile по ключу
 */
export type DeleteSafeCityEmergencyFileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteSafeCityEmergencyFileResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteSafeCityEmergencyFileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteSafeCityEmergencyFileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка файлов оповещения
 */
export type GetSafeCityEmergencyFileListRequestDto = {
}
/**
 * Ответ на запрос получения списка файлов оповещения
 */
export type GetSafeCityEmergencyFileListResponseDto = {
  /**
   * Список SafeCityEmergencyFile
   */
  data: SafeCityEmergencyFileResponseDto[]
}
/**
 * Файл оповещения
 */
export type SafeCityEmergencyFileRequestDto = {
  /**
   * Имя файла
   */
  fileName: string
  /**
   * Тело файла, строка в кодировке Base64.
   * Не возвращается с сервера.
   * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
   */
  content: Uint8Array
}
/**
 * Файл оповещения
 */
export type SafeCityEmergencyFileResponseDto = {
  /**
   * Имя файла
   */
  fileName: string
}
/**
 * Запрос загрузки файла на устройство
 */
export type SaveSafeCityEmergencyFileRequestDto = {
  /**
   * Файл оповещения
   */
  data: SafeCityEmergencyFileRequestDto
}
/**
 * Ответ на запрос загрузки файла на устройство
 */
export type SaveSafeCityEmergencyFileResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления единичной сущности SafeCityEmergencyFile по ключу
   */
  "DeleteSafeCityEmergencyFileRequest": {
    "kind": "class",
    "text": "Запрос удаления единичной сущности SafeCityEmergencyFile по ключу",
    "fields": {
      /**
       * Имя файла
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления единичной сущности SafeCityEmergencyFile по ключу
   */
  "DeleteSafeCityEmergencyFileResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления единичной сущности SafeCityEmergencyFile по ключу",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteSafeCityEmergencyFileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteSafeCityEmergencyFileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка файлов оповещения
   */
  "GetSafeCityEmergencyFileListRequest": {
    "kind": "class",
    "text": "Запрос получения списка файлов оповещения",
  },
  /**
   * Ответ на запрос получения списка файлов оповещения
   */
  "GetSafeCityEmergencyFileListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка файлов оповещения",
    "fields": {
      /**
       * Список SafeCityEmergencyFile
       */
      "data": {
        "type": "SafeCityEmergencyFile",
        "text": "Список SafeCityEmergencyFile",
      },
    },
  },
  /**
   * Файл оповещения
   */
  "SafeCityEmergencyFile": {
    "kind": "class",
    "text": "Файл оповещения",
    "fields": {
      /**
       * Имя файла
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тело файла, строка в кодировке Base64.
       * Не возвращается с сервера.
       * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
       */
      "content": {
        "type": "bytes",
        "text": "Тело файла, строка в кодировке Base64.\nНе возвращается с сервера.\nTODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах",
      },
    },
  },
  /**
   * Запрос загрузки файла на устройство
   */
  "SaveSafeCityEmergencyFileRequest": {
    "kind": "class",
    "text": "Запрос загрузки файла на устройство",
    "fields": {
      /**
       * Файл оповещения
       */
      "data": {
        "type": "SafeCityEmergencyFile",
        "text": "Файл оповещения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос загрузки файла на устройство
   */
  "SaveSafeCityEmergencyFileResponse": {
    "kind": "class",
    "text": "Ответ на запрос загрузки файла на устройство",
  },
}